<template>
  <div>
    <div class="d-flex flex-column">
      <b-row>
        <b-col md="12" class="-nowrap">
          <label>{{ $t('Name') }}:&nbsp;</label><span>{{ name }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" class="-nowrap">
          <label>{{ $t('Token') }}:&nbsp;</label><span>{{ token }}</span>
        </b-col>
      </b-row>
      <b-row>
        <div class="text-center">
          <qrcode-vue :value="urlAdvertising" :size="128" class="mb-2"></qrcode-vue>
          <p class="mb-1">
            <a :href="urlAdvertising" target="_blank" rel="noopener noreferrer">{{ urlAdvertising }}</a>
          </p>
          <div class="d-flex justify-content-center">
            <b-tooltip target="copy-button" placement="top" :title="$t('Copy Token')">
              <b-button variant="primary" size="sm" class="m-1" @click="copyToken">
                {{ $t('Copy') }}
              </b-button>
            </b-tooltip>
          </div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
export default {
  components: { QrcodeVue },
  props: ['name', 'token', 'urlAdvertising'],
  methods: {
    copyToken() {
      const copyText = `Nome: ${this.name}\nToken: ${this.token} \nLink: ${this.urlAdvertising}`;
      navigator.clipboard
        //.writeText(this.urlAction)
        .writeText(copyText)
        .then(() => {
          // A cópia do token foi bem-sucedida
          console.log('Token copied to clipboard!');
        })
        .catch((error) => {
          // Ocorreu um erro ao copiar o token
          console.error('Failed to copy token:', error);
        });
    }
  }
};
</script>

<style></style>
